export default __webpack_public_path__ + "static/contact-us-bg-lg-c48273826a13c34f4485852e496f31e8.png";